import { createRouter, createWebHistory } from 'vue-router';
import { loadGameData } from '../games';

// Lazy loading route components
const Home = () => import('../views/Home.vue');
const GameDetail = () => import('../views/GameDetail.vue');
const Categories = () => import('../views/Categories.vue');
const CategoryGames = () => import('../views/CategoryGames.vue');
const NotFound = () => import('../views/NotFound.vue');
const About = () => import('../views/About.vue');
const SearchResults = () => import('../views/SearchResults.vue');

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'GoGameVault - Play Free Online Games'
    }
  },
  {
    path: '/game/:slug',
    name: 'GameDetail',
    component: GameDetail,
    meta: {
      title: 'Play Game - GoGameVault'
    },
    // Dynamic page title setting
    beforeEnter: async (to, from, next) => {
      try {
        const game = await loadGameData(to.params.slug);
        if (game) {
          to.meta.title = `${game.i18n.en.title} - GoGameVault`;
        }
        next();
      } catch (error) {
        console.error('Failed to load game data:', error);
        next();
      }
    }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: {
      title: 'Game Categories - GoGameVault'
    }
  },
  {
    path: '/category/:tag',
    name: 'CategoryGames',
    component: CategoryGames,
    meta: {
      title: 'Category Games - GoGameVault'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'About Us - GoGameVault'
    }
  },
  {
    path: '/search',
    name: 'SearchResults',
    component: SearchResults,
    meta: {
      title: 'Search Results - GoGameVault'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'Page Not Found - GoGameVault'
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Smooth scroll to top
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  }
});

// Global navigation guard - set page title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'GoGameVault';
  next();
});

// 添加 Google Analytics 路由跟踪
router.afterEach((to) => {
  // 确保 gtag 存在
  if (window.gtag) {
    window.gtag('config', 'G-5JS8CWGEP1', {
      'page_path': to.fullPath,
    });
  }
});

export default router; 